"use client";
import { useState, useEffect, useContext } from "react";
import {
  IconButton,
  Modal,
  Typography,
  Box,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Chip,
  Card,
  CardContent,
  alpha,
  Zoom,
  Tooltip,
} from "@mui/material";

// Icons
import { Close as CloseIcon } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import DiscountIcon from "@mui/icons-material/Discount";
import PaymentIcon from "@mui/icons-material/Payment";
import InventoryIcon from "@mui/icons-material/Inventory";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StoreIcon from "@mui/icons-material/Store";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeIcon from "@mui/icons-material/Home";
import ReceiptIcon from "@mui/icons-material/Receipt";

import { useTenantNavigation } from "../../hooks/useTenantNavigation";
import { ErpContext } from "../../context/ErpContext.js";
import SpinnerLading from "../misc/SpinnerComponent.js";

const ModalViewTablaVenta = ({
  openModal,
  handleCloseModal,
  selectedTransaccion,
}) => {
  const [selectedTransaccionEntidad, setSelectedTransaccionEntidad] =
    useState(null);
  const [transaccionItems, setTransaccionItems] = useState([]);
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [totalMontoDescuento, setTotalMontoDescuento] = useState(0);
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0);
  const [montoSinImpuesto, setMontoSinImpuesto] = useState(0);
  const [itemsMap, setItemsMap] = useState({});
  const [transaccionModificable, setTransaccionModificable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarIva, setMostrarIva] = useState(false);
  const [itemsImpuestos, setItemsImpuestos] = useState({});
  const [mostrarColumnaImpuestos, setMostrarColumnaImpuestos] = useState(false);

  const navigate = useTenantNavigation();

  const {
    getTransaccionItemID,
    getEntidadByID,
    getItemById,
    ivaHardcoded,
    isNavbarCollapsed,
    getTransaccionImpuestoItems,
  } = useContext(ErpContext);

  const handleDevolucionCanje = async (transaccionCanjeVenta) => {
    console.log(transaccionCanjeVenta);
    if (transaccionCanjeVenta.length === 0) {
      console.error("No hay presupuestos disponibles para editar");
      return;
    }
    // Establecer el presupuesto a editar
    setTransaccionModificable(transaccionCanjeVenta);

    // Navegar directamente a la nueva ruta
    navigate(`gestionDevolucionVenta/${transaccionCanjeVenta.id}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedTransaccion) {
          //Estam puestos estos if porque por alguna razon hay selectedTransaccion que son undefined, por lo tanto el render del hook con MUI explota.
          // Obtener la entidad cliente
          console.log("selectedTransaccion", selectedTransaccion);
          const entidadCliente = await getEntidadByID(
            selectedTransaccion.idEntidadNumero
          );
          setSelectedTransaccionEntidad(entidadCliente);

          // La lógica de mostrarIva ahora se basa en si hay impuestos específicos de items
          // Se maneja con mostrarColumnaImpuestos que se setea después de obtener los impuestos

          // Obtener los ítems de la transacción
          const items = await getTransaccionItemID(selectedTransaccion.id);
          console.log("items de la transacción:", items);

          // Obtener impuestos de los items de la transacción
          try {
            const impuestosItems = await getTransaccionImpuestoItems(selectedTransaccion.id);
            console.log("Impuestos de items obtenidos:", impuestosItems);
            
            if (impuestosItems && impuestosItems.length > 0) {
              // Crear mapa de impuestos por item
              const impuestosMap = {};
              impuestosItems.forEach(impuesto => {
                impuestosMap[impuesto.idItem] = {
                  idImpuesto: impuesto.idImpuesto,
                  porcentaje: impuesto.porcentaje,
                  descripcionImpuesto: impuesto.descripcionImpuesto
                };
              });
              setItemsImpuestos(impuestosMap);
              setMostrarColumnaImpuestos(true);
            } else {
              setMostrarColumnaImpuestos(false);
            }
          } catch (error) {
            console.log("No se encontraron impuestos para esta transacción:", error);
            setMostrarColumnaImpuestos(false);
          }

          // Obtener los detalles de cada Item
          const itemsWithDetails = await Promise.all(
            items.map(async (item) => {
              const itemDetails = await getItemById(item.idItem); // Obtener detalles del Item
              return {
                ...item, // Mantener los datos de la transacción
                codigo: itemDetails.codigo, // Agregar el código del Item
                descripcion: itemDetails.descripcion, // Agregar la descripción del Item
              };
            })
          );

          console.log("items con detalles:", itemsWithDetails);
          setTransaccionItems(itemsWithDetails);

          // Crear el mapa de ítems
          const itemsMap = itemsWithDetails.reduce((map, item) => {
            map[item.idItem] = {
              codigo: item.codigo,
              descripcion: item.descripcion,
            };
            return map;
          }, {});

          setItemsMap(itemsMap);

          // Calcular montos
          const {
            montoTotal,
            impuestos = [],
            montoDescuento = 0,
            porcentajeDescuento = 0,
          } = selectedTransaccion;

          const totalSinImpuestos = impuestos
            .filter(
              (impuesto) => !impuesto.eliminado && !impuesto.incluidoEnPrecio
            )
            .reduce((total, impuesto) => {
              const monto = impuesto.montoTotal || 0;
              console.log(
                `Total acumulado: ${total}, Impuesto aplicado: ${monto}`
              );
              return total - monto;
            }, montoTotal);

          console.log(
            "Resultado final de totalSinImpuestos:",
            totalSinImpuestos
          );

          // Aplicar descuentos
          console.log(totalSinImpuestos + " + " + montoDescuento);
          const totalSinImpuestosYDescuento =
            totalSinImpuestos + montoDescuento;
          const totalFinal =
            totalSinImpuestosYDescuento * (1 - porcentajeDescuento / 100);

          // Actualizar estados
          setCalculatedTotal(totalFinal);
          setTotalMontoDescuento(montoDescuento);
          setPorcentajeDescuento(porcentajeDescuento);
          setMontoSinImpuesto(totalSinImpuestosYDescuento);
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      } finally {
        setLoading(false); // Ocultar el spinner independientemente del resultado
      }
    };

    fetchData();
  }, [selectedTransaccion]);

  // Renderiza el spinner mientras está cargando
  if (loading) {
    return <SpinnerLading />;
  }

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-transaccion-titulo"
      aria-describedby="modal-transaccion-descripcion"
    >
      <Box
        className="modal-background"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxHeight: "90vh",
        }}
      >
        <Zoom in={openModal} timeout={300}>
          <Paper className="modal-container">
            {/* Header */}
            <Box
              sx={{
                bgcolor: "#5b5b5f",
                color: "white",
                p: 2,
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <ReceiptIcon />
                <Typography
                  variant="h6"
                  component="h2"
                  className="modal-title"
                  sx={{ color: "white", borderBottom: "none", m: 0, p: 0 }}
                >
                  Detalles de la Transacción #{selectedTransaccion?.id}
                </Typography>
                {selectedTransaccion?.tipoFacturaDescripcion && (
                  <Chip
                    label={selectedTransaccion.tipoFacturaDescripcion}
                    size="small"
                    color="secondary"
                    sx={{
                      bgcolor: "rgb(244, 177, 14)",
                      color: "black",
                      fontWeight: "bold",
                      ml: 2,
                    }}
                  />
                )}
              </Box>
              <IconButton
                onClick={handleCloseModal}
                sx={{ color: "white" }}
                className="close-button"
                aria-label="cerrar"
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Content */}
            <Box sx={{ p: 3 }}>
              {/* Información principal */}
              <Grid container spacing={3} sx={{ mb: 3 }}>
                {/* Datos ERP */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #5b5b5f",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <BusinessIcon sx={{ color: "#5b5b5f" }} />
                        Datos ERP
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <CalendarTodayIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Fecha:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                          >
                            {selectedTransaccion?.createdAt}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <DescriptionIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Tipo:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{
                              color:
                                selectedTransaccion.idTipoTransaccionID == 1
                                  ? "#4CAF50"
                                  : "#757575",
                              fontWeight: "bold",
                            }}
                          >
                            {selectedTransaccion?.idTipoTransaccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <StoreIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Negocio:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                          >
                            {selectedTransaccion?.negocio || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <AccountCircleIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Usuario:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                          >
                            {selectedTransaccion?.usuario || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Ubicación:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                          >
                            {selectedTransaccion?.ubicacion || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Cliente */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid rgb(244, 177, 14)",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <PersonIcon sx={{ color: "rgb(244, 177, 14)" }} />
                        Datos del Cliente
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <PersonIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Nombre:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                            sx={{ fontWeight: "500" }}
                          >
                            {selectedTransaccion?.descripcionEntidad}{" "}
                            {selectedTransaccion?.apellido || ""}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <DescriptionIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            DNI/CUIT:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                          >
                            {selectedTransaccion?.dniCuitCuil || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <HomeIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Dirección:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                          >
                            {selectedTransaccion?.direccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Localidad:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                          >
                            {selectedTransaccion?.localidad || "N/A"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Provincia:
                          </Typography>
                          <Typography
                            variant="body2"
                            className="transaction-detail-value"
                          >
                            {selectedTransaccion?.provincia || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Financieros */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #4CAF50",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <AttachMoneyIcon sx={{ color: "#4CAF50" }} />
                        Datos Financieros
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        {/* Subtotal */}
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <AttachMoneyIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Subtotal:
                          </Typography>
                          <Typography variant="body2" className="value">
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(montoSinImpuesto || 0)}
                          </Typography>
                        </Box>

                        {/* Descuentos */}
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <DiscountIcon fontSize="small" color="action" />
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Descuento:
                          </Typography>
                          <Typography variant="body2" className="value">
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(totalMontoDescuento || 0)}
                            {porcentajeDescuento > 0 &&
                              ` (${porcentajeDescuento}%)`}
                          </Typography>
                        </Box>

                        {(() => {
                          const pagoCheque = selectedTransaccion?.pagos?.find(
                            (p) => p.idTipoMedio === 8
                          );
                          return pagoCheque ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Typography
                            variant="body2"
                            className="transaction-detail-label"
                          >
                            Datos Cheque
                          </Typography>
                              <Typography variant="body2" className="value">
                                {selectedTransaccion.descripcion}
                              </Typography>
                            </Box>
                          ) : null;
                        })()}

                        {/* Impuestos */}
                        {selectedTransaccion?.impuestos &&
                          selectedTransaccion.impuestos.length > 0 && (
                            <Box>
                              <Typography
                                variant="body2"
                                className="transaction-detail-label"
                                sx={{ mb: 0.5 }}
                              >
                                Impuestos:
                              </Typography>

                              {selectedTransaccion.impuestos.every(
                                (imp) => !imp.incluidoEnPrecio
                              ) ? (
                                selectedTransaccion.impuestos
                                  .filter((imp) => !imp.eliminado)
                                  .map((imp, idx) => (
                                    <Box
                                      key={idx}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        ml: 3,
                                        gap: 1,
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        className="transaction-detail-label"
                                      >
                                        • {imp.descripcion} ({imp.porcentaje}%):
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        className="value"
                                      >
                                        {new Intl.NumberFormat("es-AR", {
                                          style: "currency",
                                          currency: "ARS",
                                        }).format(imp.montoTotal || 0)}
                                      </Typography>
                                    </Box>
                                  ))
                              ) : (
                                <Typography
                                  variant="body2"
                                  sx={{ ml: 3, fontStyle: "italic" }}
                                >
                                  Los impuestos están incluidos en el total
                                </Typography>
                              )}
                            </Box>
                          )}

                        {/* Total */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mt: 1,
                            p: 1,
                            bgcolor: alpha("#4CAF50", 0.1),
                            borderRadius: 1,
                          }}
                        >
                          <AttachMoneyIcon
                            fontSize="small"
                            sx={{ color: "#4CAF50" }}
                          />
                          <Typography
                            variant="body1"
                            className="transaction-detail-label"
                            fontWeight="bold"
                          >
                            Total:
                          </Typography>
                          <Typography variant="body1" className="value">
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(selectedTransaccion?.montoTotal || 0)}
                          </Typography>
                        </Box>

                        {/* Medios de Pago */}
                        <Box sx={{ mt: 1 }}>
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                            sx={{
                              mb: 0.5,
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <PaymentIcon fontSize="small" />
                            Medios de Pago:
                          </Typography>

                          {selectedTransaccion?.pagos?.length > 0 ? (
                            selectedTransaccion.pagos.map((pago, idx) => (
                              <Box
                                key={idx}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  ml: 3,
                                  gap: 1,
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  className="transaction-detail-label"
                                >
                                  • {pago.descripcion}:
                                </Typography>
                                <Typography variant="body2" className="value">
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(pago.monto || 0)}
                                </Typography>
                              </Box>
                            ))
                          ) : (
                            <Typography
                              variant="body2"
                              sx={{ ml: 3, fontStyle: "italic" }}
                            >
                              No hay información de pagos
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Tabla de Ítems */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="h6"
                  className="items-title"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: "#5b5b5f",
                  }}
                >
                  <InventoryIcon />
                  Ítems de la Transacción
                </Typography>

                <TableContainer
                  component={Paper}
                  elevation={3}
                  className="tableContainerItemList"
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    maxHeight: 300,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell className="table-header-cell">
                          Descripción
                        </TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Cantidad
                        </TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Precio Unitario
                        </TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Descuento
                        </TableCell>
                        {mostrarColumnaImpuestos && (
                          <TableCell
                            align="right"
                            className="table-header-cell"
                          >
                            IVA
                          </TableCell>
                        )}
                        <TableCell align="right" className="table-header-cell">
                          Total
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {transaccionItems.length > 0 ? (
                        transaccionItems.map((item, index) => {
                          const precio = item.precio || 0;
                          const cantidad = item.cantidad || 0;
                          const descuento = item.porcentajeDescuento || 0;
                          const totalItem = (
                            precio *
                            cantidad *
                            (1 - descuento / 100)
                          ).toFixed(2);

                          const foundItem = itemsMap[item.idItem];

                          return (
                            <TableRow
                              key={`${item.idTransaccion}-${item.idItem}-${index}`}
                              className={
                                index % 2 === 0
                                  ? "row-color-default"
                                  : "row-color-alt"
                              }
                              sx={{
                                transition: "background-color 0.2s ease",
                                "&:hover": {
                                  backgroundColor: alpha("#5b5b5f", 0.05),
                                },
                              }}
                            >
                              <TableCell className="table-cell">
                                <Typography variant="body2" fontWeight="medium">
                                  {foundItem
                                    ? `${foundItem.codigo} - ${foundItem.descripcion}`
                                    : "No encontrado"}
                                </Typography>
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                <Chip
                                  label={cantidad}
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(precio)}
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                {descuento > 0 ? (
                                  <Chip
                                    label={`${descuento}%`}
                                    size="small"
                                    color="secondary"
                                    variant="outlined"
                                  />
                                ) : (
                                  "0%"
                                )}
                              </TableCell>
                              {mostrarColumnaImpuestos && (
                                <TableCell align="right" className="table-cell">
                                  {(() => {
                                    const impuestoItem = itemsImpuestos[item.idItem];
                                    if (impuestoItem) {
                                      return (
                                        <Chip 
                                          label={`${impuestoItem.porcentaje}%`} 
                                          size="small" 
                                          color="success" 
                                          variant="outlined"
                                          title={impuestoItem.descripcionImpuesto || `IVA ${impuestoItem.porcentaje}%`}
                                        />
                                      );
                                    }
                                    return "N/A";
                                  })()}
                                </TableCell>
                              )}
                              <TableCell align="right" className="table-cell">
                                <span className="value">
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(totalItem)}
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={mostrarColumnaImpuestos ? 6 : 5}
                            align="center"
                            sx={{ py: 3 }}
                          >
                            <Typography variant="body1" color="text.secondary">
                              No hay ítems para mostrar
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Acciones */}
              {/* Botón Devolución / Canje oculto */}
            </Box>
          </Paper>
        </Zoom>
      </Box>
    </Modal>
  );
};

export default ModalViewTablaVenta;
